export default "__VITE_ASSET__DYcNH$4H__"